import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { useNavigate } from "react-router-dom";
import { Button, Grid } from "@mui/material";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import AddSocietyAdmin from "../AllSociety/AddSocietyAdmin";
// End

// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";

import DeleteIcon from "@mui/icons-material/Delete";
// import CreateIcon from "@mui/icons-material/Create";
import swal from "sweetalert";
import Pagination from "@mui/material/Pagination";

import { makePostRequest } from "../../../utils/utils";

function SocietyAdmin() {
  const navigate = useNavigate();

  // const [anchorEl, setAnchorEl] = React.useState(null);
  // const open2 = Boolean(anchorEl);
  const [adminList, setAdminList] = React.useState([]);
  const [q, setQ] = React.useState("");
  // const [, setStatus] = React.useState("");
  const [dumypicture] = React.useState(
    require("../../../assets/Images/avtarPic.png")
  );

   //pagination
   const [currentPage, setCurrentPage] = React.useState(1);
   const [itemsPerPage] = React.useState(5);
   const [totalItems, setTotalItems] = React.useState(0);
 
 
   const handlePageChange = (e, page) => {
     setCurrentPage(page);
   };

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };
  // const handleClose2 = (e) => {
  //   setAnchorEl(null);
  //   let st = e.currentTarget.dataset.myValue;
  //   setStatus(st);
  //   // window.location.reload();
  // };

  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  async function SocietyAdminListing() {
    let bodyFormData = {};

    await makePostRequest(
      "societyconfiguration/configurationlisting?searchq=" +
        q +
        "&pageNo=" +
        currentPage +"&count=" +
        itemsPerPage ,
      bodyFormData
    )
      .then((response) => {
        console.log(response);
        if (response.status == "201") {
          const data = response.data.data.data;
          setAdminList(data);
          setTotalItems(response.data.data.total_records);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        let errMsg = err.response.data.message;

        swal(errMsg, "", "warning");
        navigate("/");
      });
  }

  const descriptionElementRef = React.useRef(null);

  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    SocietyAdminListing();
  }, [q,currentPage]);
  // End

  React.useEffect(() => {
    if (q) {
      setCurrentPage(1);
    }
  }, [q]);

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Society Admin List</h1>
            <Button className="primaryBtn" onClick={handleClickOpen("body")}>
              Add Society Admin
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="visitorListNewOut">
                <div className="visitorHead">Society Admin List</div>
                <div className="visitorListNewInner">
                  <div className="visitorSearch">
                    <div className="visitorSearchDiv">
                      <SearchIcon className="visitorSearchIco" />
                      <input
                        type="text"
                        placeholder="Search"
                        onChangeCapture={(e) => setQ(e.target.value)}
                      />
                      {/* <MicIcon className="visitorMicIco" /> */}
                    </div>
                    {/* <SortIcon
                      className="visitorFilterIco"
                      aria-controls={open2 ? "basic-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open2 ? "true" : undefined}
                      onClick={handleClick}
                    />
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open2}
                      onClose={handleClose2}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      <MenuItem
                        data-my-value={"approved"}
                        onClick={handleClose2}
                      >
                        filter 1
                      </MenuItem>
                      <MenuItem
                        data-my-value={"pending"}
                        onClick={handleClose2}
                      >
                        filter 2
                      </MenuItem>
                      <MenuItem
                        data-my-value={"rejected"}
                        onClick={handleClose2}
                      >
                        filter 3
                      </MenuItem>
                      <MenuItem data-my-value={"active"} onClick={handleClose2}>
                        filter 4
                      </MenuItem>
                      <MenuItem
                        data-my-value={"preapproved"}
                        onClick={handleClose2}
                      >
                        filter 5
                      </MenuItem>
                    </Menu> */}
                  </div>
                  {adminList.map((option) => (
                    <div className="visitContDiv" key={option.rsident_id}>
                      <div className="visitCont1 resideNewContOut">
                        <div className="visitContProf linkCOnt">
                          {option.user_obj.profile_pic ? (
                            <img src={option.user_obj.profile_pic} />
                          ) : (
                            <img src={dumypicture} />
                          )}
                        </div>
                        <div className="visitContLeft linkCOnt">
                          <h3 className="visitContHed">
                            {option.user_obj.first_name}{" "}
                            {option.user_obj.last_name} ({option.user_obj.age})
                          </h3>
                          <p className="visitContMob">
                            {option.user_obj.contact_no}
                          </p>
                          <p className="visitContTime">
                            {option.user_obj.email_id}
                          </p>
                        </div>
                        <div className="visitBottCont">
                          <p>Society Name</p>
                          <div>
                            <b>{option.society_name} </b>
                          </div>
                        </div>
                        <div className="resideNewCont">
                          {/* <CreateIcon className="editBt" /> */}
                          <DeleteIcon className="deleteBt" />
                        </div>
                      </div>
                    </div>
                  ))}
                  <Grid container spacing={3} >
                    <Grid item xs={12} md={12} >
                      <Pagination count={Math.ceil(totalItems / itemsPerPage)}
                        page={currentPage}
                        onChange={handlePageChange}
                        variant="outlined"
                        shape="rounded" />
                    </Grid>
                  </Grid>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Society Admin</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <AddSocietyAdmin />
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
}

export default SocietyAdmin;
